import { useAction } from '@src/redux/hooks/useAction';
import { useAsync } from '@src/redux/hooks/useAsync';
import { useSelect } from '@src/redux/hooks/useSelect';
import { verifyMedicaid } from './actions';
import { VERIFY_MEDICAID } from './constants';

const medicaidInfoSelector = (state) => {
  return state.medicaid;
};

export const useMedicaid = {
  state: () => {
    return useSelect(medicaidInfoSelector);
  },
  actions: () => {
    return {
      verifyMedicaid: useAction(verifyMedicaid, {
        saga: useAsync(VERIFY_MEDICAID),
      }),
    };
  },
};
